import React, { useState, useEffect } from "react";
import {
  TextField,
  ThemeProvider,
  createTheme,
  Autocomplete,
  Button,
} from "@mui/material";
import { Fragment, useMemo, useRef } from "react";
import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import axios from "axios";
// import { common_axios } from "../../..";
import { common_axios } from "../../../App";
import { Form, Formik, useFormik, Field, FieldArray } from "formik";
import * as yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import Loader from "../../../components/Loader";
import Backdrop from "@mui/material/Backdrop";
import DeleteIcon from "@mui/icons-material/Delete";
import ColumnFilter from "../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
import { InputAdornment, Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { withRouter } from "react-router-dom";
import RuleIcon from "@mui/icons-material/Rule";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import TextareaAutosize from "@mui/material/TextareaAutosize";
const ManageBulkGroup = () => {
  // ...................................Theme Provider....................................//

  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: { color: "red" },
        },
      },
    },
  });

//   async function FilterPost(values) {
//     try {
//       setOpen(true);
//       const res = await common_axios.post(
//         "http://192.168.167.66:5002/v1/drools-rule/save",
//         {
//           keyword: values.keyword,
//           response: "false",
//         }
//       );
//       if (res.data.statusDescription.statuscode == 200) {
//         setOpen(false);
//         FilterGet();
//         toast.success("Keyword added successfully!!", {
//           theme: "colored",
//         });
//         values.keyword = "";
//       } else if (res.data.statusDescription.statuscode == 202) {
//         toast.error("Keyword already exists !!", {
//           theme: "colored",
//         });

//         setOpen(false);
//       } else {
//         setOpen(false);
//         toast.error(res.data.statusDescription.statusdescription);
//       }
//     } catch (error) {
//       setOpen(false);
//       toast.error("Please Check Your Network");
//     }
//   }

  return (
   <>
     <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">

{/* <body class="p-0"> */}
    {/* <!--cmp-section--> */}
    <section class="cmp">
        <div class="container-fluid">
            <div class="row">
               
                {/* <!--right-panel-section--> */}
                <section class="col-md-9 right_panel px-0">
                 
                    <div class="container-fluid_1">
                        {/* <!--manage-list-section--> */}
                        <section class="manage_list" id='manage_list'>
                            <div class="flt_start">
                            <a href="#" class="d-flex align-items-center float-start add_new" data-bs-toggle="modal" data-bs-target="#exampleModal6"><i class="fas fa-plus d-block"></i><span class="ms-1 d-block">add new bulk group</span></a>
                           </div>
                            <div class="table-responsive mt-3">
                                <table class="table table-striped table-bordered table-sm dataTable no-footer">
                                    <thead>
                                        <tr>
                                            <th>group id</th>
                                            <th>group name</th>
                                            <th>count of lists</th>
                                            <th>action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>111</td>
                                            <td>asdc</td>
                                            <td>3432423439</td>
                                            <td>
                                                <div class="dropdown">
                                                    <a class="btn dropdown-toggle d-flex align-items-center user_icon p-0" href="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                                                        <i class="fas fa-user me-1"></i>
                                                    </a>
                                                  
                                                    <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink" id="sub_menu">
                                                      <li><a class="dropdown-item" href="#">Edit</a></li>
                                                      <li><a class="dropdown-item" href="#">Delete</a></li>
                                                      <li><a class="dropdown-item" href="#">Add Contact</a></li>
                                                      <li><a class="dropdown-item" href="#">Remove</a></li>
                                                    </ul>
                                                  </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>111</td>
                                            <td>asdc</td>
                                            <td>3432423439</td>
                                            <td>
                                                <div class="dropdown">
                                                    <a class="btn dropdown-toggle d-flex align-items-center user_icon p-0" href="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                                                        <i class="fas fa-user me-1"></i>
                                                    </a>
                                                  
                                                    <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink" id="sub_menu">
                                                      <li><a class="dropdown-item" href="#">Edit</a></li>
                                                      <li><a class="dropdown-item" href="#">Delete</a></li>
                                                      <li><a class="dropdown-item" href="#">Add Contact</a></li>
                                                      <li><a class="dropdown-item" href="#">Remove</a></li>
                                                    </ul>
                                                  </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>111</td>
                                            <td>asdc</td>
                                            <td>3432423439</td>
                                            <td>
                                                <div class="dropdown">
                                                    <a class="btn dropdown-toggle d-flex align-items-center user_icon p-0" href="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                                                        <i class="fas fa-user me-1"></i>
                                                    </a>
                                                  
                                                    <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink" id="sub_menu">
                                                      <li><a class="dropdown-item" href="#">Edit</a></li>
                                                      <li><a class="dropdown-item" href="#">Delete</a></li>
                                                      <li><a class="dropdown-item" href="#">Add Contact</a></li>
                                                      <li><a class="dropdown-item" href="#">Remove</a></li>
                                                    </ul>
                                                  </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>111</td>
                                            <td>asdc</td>
                                            <td>3432423439</td>
                                            <td>
                                                <div class="dropdown">
                                                    <a class="btn dropdown-toggle d-flex align-items-center user_icon p-0" href="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                                                        <i class="fas fa-user me-1"></i>
                                                    </a>
                                                  
                                                    <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink" id="sub_menu">
                                                      <li><a class="dropdown-item" href="#">Edit</a></li>
                                                      <li><a class="dropdown-item" href="#">Delete</a></li>
                                                      <li><a class="dropdown-item" href="#">Add Contact</a></li>
                                                      <li><a class="dropdown-item" href="#">Remove</a></li>
                                                    </ul>
                                                  </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>111</td>
                                            <td>asdc</td>
                                            <td>3432423439</td>
                                            <td>
                                                <div class="dropdown">
                                                    <a class="btn dropdown-toggle d-flex align-items-center user_icon p-0" href="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                                                        <i class="fas fa-user me-1"></i>
                                                    </a>
                                                  
                                                    <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink" id="sub_menu">
                                                      <li><a class="dropdown-item" href="#">Edit</a></li>
                                                      <li><a class="dropdown-item" href="#">Delete</a></li>
                                                      <li><a class="dropdown-item" href="#">Add Contact</a></li>
                                                      <li><a class="dropdown-item" href="#">Remove</a></li>
                                                    </ul>
                                                  </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </section>
                        {/* <!--x-manage-list-section-x--> */}
                    </div>
                </section>
                {/* <!--x-right-panel-section-x--> */}
            </div>
        </div>
    </section>
    {/* <!--x-cmp-section-x-->
    <!--modal-section--> */}
    <section class="modal_1">
        {/* <!-- Button trigger modal --> */}
        {/* <!-- <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
            Launch demo modal
        </button> --> */}

        {/* <!-- Modal --> */}
        <div class="modal fade" id="exampleModal6" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <ThemeProvider theme={theme}>

                <div class="modal-body">
                  <form class="m-0">
                      <div class="">
                        <div class="row align-items-center">
                            <div class="col-4">
                                <label for="exampleInputEmail1" class="form-label m-0">Number List Name:</label>
                            </div>  
                            <div class="col-8">
                                {/* <input type="text" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"/> */}
                                <TextField
                                className=" w-100"
                                style={{
                                  borderRadius: "4px",
                                }}
                                type="text"
                                label="Number List"
                                name="mobileNumber"
                                variant="outlined"
                                size="small"
                                required
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <Tooltip
                                          title="Number List"
                                          placement="top"
                                          arrow
                                          sx={{ color: "#85CBF2" }}
                                        >
                                          <InfoIcon />
                                        </Tooltip>
                                      </InputAdornment>
                                    ),
                                  }}
                                //   onChange={formik.handleChange}
                                //   value={formik.values.mobileNumber}
                                //   error={
                                //     formik.touched.mobileNumber && Boolean(formik.errors.mobileNumber)
                                //   }
                                //   helperText={formik.touched.mobileNumber && formik.errors.mobileNumber}
                              />
                            </div>  
                        </div>
                        <div class="row mt-2">
                            <div class="col-4">
                                <label for="exampleInputTextarea" class="form-label m-0">description:</label>
                            </div>  
                            <div class="col-8">
                                {/* <textarea class="form-control" placeholder="Leave a comment here" id="exampleInputTextarea"></textarea> */}
                                <TextareaAutosize
                              //  disabled
                              textarea_8
                              aria-label="empty textarea"
                              placeholder="Empty"
                              name="description"
                              style={{ width:" 305px", minHeight:"50px", borderColor:" #48a8dd"}}
                            //   maxlength="100"
                              // value={ruleview}
                            //   required
                            //   onChange={formik.handleChange}
                            //         value={formik.values.description}
                            //         error={
                            //           formik.touched.description &&
                            //           Boolean(formik.errors.description)
                            //         }
                            //         helperText={
                            //           formik.touched.description &&
                            //           formik.errors.description
                            //         }

                                    
                            />


                            </div>  
                        </div>
                    </div>
                    <div class="bxg_8 mt-3">
                        {/* <div class="flt_start">
                            <div class="float-start d-flex align-items-center flex-wrap">
                                
                                    <div class="form-check">
                                        <div class="">
                                        <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" onclick="radio_1()"/>
                                        </div>
                                        <label class="form-check-label" for="flexRadioDefault1">
                                        from file
                                        </label>
                                    </div>
                                    <div class="form-check ms-2">
                                        <div class="">
                                        <input class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" onclick="radio_2()" checked=""/>
                                        </div>
                                        <label class="form-check-label" for="flexRadioDefault2">
                                        direct input
                                        </label>
                                    </div>
                             
                            </div>
                        </div>
                        <div class="row align-items-center my-2">
                            <div class="col-4">
                                <label for="exampleInputEmail1" class="form-label m-0">upload from csv/txt/xls/xlsx</label>
                            </div>
                            <div class="col-8">
                                <input type="file" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"/>
                            </div>
                        </div>
                        <p><b class="text-capitalize">note:</b> jdksvc ewbhvber webvweb vfvvwer fvewrre vferwver vfervgrv dfverv vfrev vferver vfrerre vferver vrrervr</p> */}
                       
                        <select
                                      className="form-control form-select"
                                      name="choices-button"
                                      id="exampleFormControlSelect1"
                                      // required
                                    //   onChange={(e) => {
                                    //     setAge(e.target.value);
                                    //   }}
                                    //   value={age}

                                    >
                                      <option value={0}>Deactivate</option>
                                      <option value={1}>Activate</option>
                                    </select>
                    </div>
                    {/* <button type="button" class="btn btn-primary d-flex align-items-center text-capitalize m-0 ms-auto mt-4"><i class="fas fa-save d-block"></i><span class="d-block ms-1">upload & save</span></button> */}
                  </form>
                </div>
                <div class="modal-footer">
                <button type="button" class="btn btn-primary">Save changes</button>
                  <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              
                </div>
                </ThemeProvider>
              </div>
              
            </div>
          </div>

    </section>
    {/* <!--x-modal-section-x-->
    <!-- jQuery first, then Popper.js, then Bootstrap JS --> */}
 
 {/* </body> */}
</main>
   </>
  )
}

export default ManageBulkGroup